export type TrainingPathEntry = {
  id: string
  targetClass: string
}

export const TRAINING_PATH_ENTRIES: TrainingPathEntry[] = [
  { id: 'A_DIREKT',              targetClass: 'A'    },
  { id: 'A_FIRST',               targetClass: 'A'    },
  { id: 'A_EXT',                 targetClass: 'A'    },
  { id: 'A_FROM_A1_A2_NO_STEP',  targetClass: 'A'    },
  { id: 'A_FROM_A2_GE_2Y',       targetClass: 'A'    },
  { id: 'A1_EXT',                targetClass: 'A1'   },
  { id: 'A1_FIRST',              targetClass: 'A1'   },
  { id: 'A2_DIREKT',             targetClass: 'A2'   },
  { id: 'A2_FIRST',              targetClass: 'A2'   },
  { id: 'A2_EXT',                targetClass: 'A2'   },
  { id: 'A2_FROM_A1_GE_2Y',      targetClass: 'A2'   },
  { id: 'A2_FROM_A1_LT_2Y',      targetClass: 'A2'   },
  { id: 'AM_EXT',                targetClass: 'AM'   },
  { id: 'AM_FIRST',              targetClass: 'AM'   },
  { id: 'B_EXT',                 targetClass: 'B'    },
  { id: 'B_FIRST',               targetClass: 'B'    },
  { id: 'BA_B78_EXT',            targetClass: 'B78'  },
  { id: 'BA_B78_FIRST',          targetClass: 'B78'  },
  { id: 'BA_B78_EXT',            targetClass: 'BA'   },
  { id: 'BA_B78_FIRST',          targetClass: 'BA'   },
  { id: 'B196',                  targetClass: 'B196' },
  { id: 'B197_FIRST',            targetClass: 'B197' },
  { id: 'B197_EXT',              targetClass: 'B197' },
  { id: 'B96',                   targetClass: 'B96'  },
  { id: 'BE_FROM_B',             targetClass: 'BE'   },
  { id: 'C_FROM_B',              targetClass: 'C'    },
  { id: 'C_FROM_C1',             targetClass: 'C'    },
  { id: 'C_FROM_D',              targetClass: 'C'    },
  { id: 'C_FROM_D1',             targetClass: 'C'    },
  { id: 'C1_FROM_B',             targetClass: 'C1'   },
  { id: 'C1_FROM_D1_D',          targetClass: 'C1'   },
  { id: 'C1E_FROM_C1',           targetClass: 'C1E'  },
  { id: 'CE_FROM_C',             targetClass: 'CE'   },
  { id: 'D_FROM_B_GT_2Y',        targetClass: 'D'    },
  { id: 'D_FROM_B_LE_2Y',        targetClass: 'D'    },
  { id: 'D_FROM_C_GT_2Y',        targetClass: 'D'    },
  { id: 'D_FROM_C_LE_2Y',        targetClass: 'D'    },
  { id: 'D_FROM_C1_GT_2Y',       targetClass: 'D'    },
  { id: 'D_FROM_C1_LE_2Y',       targetClass: 'D'    },
  { id: 'D_FROM_D1',             targetClass: 'D'    },
  { id: 'D1_FROM_B_C1_GT_2Y',    targetClass: 'D1'   },
  { id: 'D1_FROM_B_C1_LE_2Y',    targetClass: 'D1'   },
  { id: 'D1_FROM_C_GT_2Y',       targetClass: 'D1'   },
  { id: 'D1_FROM_C_LE_2Y',       targetClass: 'D1'   },
  { id: 'D1E_FROM_D1',           targetClass: 'D1E'  },
  { id: 'DE_FROM_D',             targetClass: 'DE'   },
  { id: 'L_EXT',                 targetClass: 'L'    },
  { id: 'L_FIRST',               targetClass: 'L'    },
  { id: 'MOFA_SINGLE',           targetClass: 'Mofa' },
  { id: 'MOFA_GROUP',            targetClass: 'Mofa' },
  { id: 'T_EXT',                 targetClass: 'T'    },
  { id: 'T_FIRST',               targetClass: 'T'    },
]

type FormatMessage = (descriptor: { id: string; defaultMessage?: string }) => string

export const formatTrainingPathLabel = (
  intl: { formatMessage: FormatMessage },
  trainingPathId: string,
): string =>
  intl.formatMessage({ id: `training_path_${trainingPathId}`, defaultMessage: trainingPathId })

export const getTrainingPathsForLicense = (licenseCode: string): TrainingPathEntry[] =>
  TRAINING_PATH_ENTRIES.filter((e) => e.targetClass === licenseCode)
